import React, { useState, useEffect } from "react";
import "./PackagesList.css";
import { Container } from "react-bootstrap";
import {
  Header,
  Breadcrumb,
  PackagesCardList,
} from "../../Features/PackagesList";
import { useLocation } from "react-router-dom";
import { NotFound } from "../../components";
import { useParams } from "react-router-dom";
import { axiosGet } from "../../utils/apis/api";
import { useTranslation } from '../../contexts/TranslationContext';


const PackagesList = ({ errorNotFound, pageData, url }) => {
  const { category } = useParams();
  const { t } = useTranslation();
  const [data, setData] = useState([]);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalPages: 1,
  });
  const [isLoading, setIsLoading] = useState(false);
  const resultsPerPage = 6;

  const [localError, setLocalError] = useState(null);

  const location = useLocation();
  // const { search, destinations, categoryhero } = location.state || {};

  const query = new URLSearchParams(location.search);

  const search = query.get("search") || "";
  const categoryhero = query.get("category") || "";
  const destinations = query.get("destinations") || "";
  const categoryFilter = category || query.get("category") || "";


  const hasFilters =
  query.get("search") ||
  query.get("destinations") ||
  query.get("category");




const fetchData = async (pageNumber = 1) => {
  try {
    const start = (pageNumber - 1) * resultsPerPage;
    let apiUrl = `${url}/api/method/alltimes.alltimes_travel.doctype.ready_package.ready_package.allTimePackage?start=${start}&limit=${resultsPerPage}`;

    if (search) apiUrl += `&search=${encodeURIComponent(search)}`;
    if (destinations) {
      apiUrl += `&destinations=${encodeURIComponent(destinations)}`;
    }
    if (categoryFilter) apiUrl += `&category=${encodeURIComponent(categoryFilter)}`;


    setIsLoading(true);
    setLocalError(null); // clear previous error

    const response = await axiosGet(apiUrl);
    const result = response.result;

    setData(result.packages || []);
    setPagination({
      currentPage: result.pagination.metadata.current_page,
      totalPages: result.pagination.metadata.total_pages,
    });
    setIsLoading(false);
  } catch (error) {
    console.error("Fetch failed", error.message);

    setLocalError({
      code: error.response?.status || 500,
      message: "API Error",
      description: error.message || "Unknown error",
    });
    setIsLoading(false);
  }
};


  // const fetchData = async (pageNumber = 1) => {
  //   try {
  //     const start = (pageNumber - 1) * resultsPerPage;
  //     let apiUrl = `${url}/api/method/alltimes.alltimes_travel.doctype.ready_package.ready_package.allTimePackage?start=${start}&limit=${resultsPerPage}`;

  //     if (search) apiUrl += `&search=${encodeURIComponent(search)}`;
  //     if (destinations.length)
  //       apiUrl += `&destinations=${encodeURIComponent(
  //         JSON.stringify(destinations)
  //       )}`;
  //     if (category) apiUrl += `&category=${encodeURIComponent(category)}`;

  //     setIsLoading(true);
  //     setLocalError(null); // clear previous error

  //     const response = await axiosGet(apiUrl);
  //     const result = response.result;

  //     setData(result.packages || []);
  //     setPagination({
  //       currentPage: result.pagination.metadata.current_page,
  //       totalPages: result.pagination.metadata.total_pages,
  //     });
  //     setIsLoading(false);
  //   } catch (error) {
  //     console.error("Fetch failed", error.message);

  //     setLocalError({
  //       code: error.response?.status || 500,
  //       message: "API Error",
  //       description: error.message || "Unknown error",
  //     });
  //     setIsLoading(false);
  //   }
  // };

  
    // Fetch data when any filter changes
    useEffect(() => {
      fetchData(1);
    }, [search, destinations, categoryFilter]);

  return (
    <Container
      className="PackagesList-page-container"
      data-aos="fade"
      data-aos-duration="1000"
    >
      <Header pageData={data} />
      <Breadcrumb category={category} data={data} />
      {/* <PackagesCardList pageDataList={data?.content?.package_list} url={url} category={category}/> */}
      {errorNotFound || localError || (data.length === 0 && !isLoading) ? (
        <NotFound
          errorCode={String(errorNotFound?.code || localError?.code || "404")}
          errorMessage={String(
            errorNotFound?.message || localError?.message || t("NoResultsFound")
          )}
          description={String(
            errorNotFound?.description ||
              localError?.description ||
              t("NoResultsFoundText")
          )}
        />
      ) : (
        <PackagesCardList
          errorNotFound={errorNotFound}
          data={data}
          url={url}
          category={category}
          currentPage={pagination.currentPage}
          totalPages={pagination.totalPages}
          isLoading={isLoading}
          onPageChange={(page) => fetchData(page)}
        />
      )}
    </Container>
  );
};

export default PackagesList;
